import type { CoachMarkSpec } from '@/features/coach-marks';

export const APP_ACCESS_SWITCH_COACH_MARK: CoachMarkSpec = {
  id: 'appAccessSwitchDirection',
  version: 'v1',
  title: 'On now means included',
  description:
    'App switches now work the same way in every mode. Turn an app on to let Littlebird read it, or off to exclude it. Your saved app choices have not changed.',
  width: 'md',
};
